import React, { useEffect, useState } from "react";
import { Box, Container, Heading, VStack, SimpleGrid } from "@chakra-ui/react";

import { getHelpContent } from "api/webservice/content";
import { ReactComponent as Logo } from "assets/logo.svg";
import { BasicLayout } from "layouts";
import Categories from "./Categories";
import Section from "./Section";

const Help: React.FC = () => {
  const [helpCategories, setHelpCategories] = useState([]);
  const [activeIndex, setActiveIndex] = useState(0);
  // @ts-ignore
  const topics = helpCategories[activeIndex]
    ? // @ts-ignore
    helpCategories[activeIndex].topics?.filter(item => (item.tag == null || item.tag.includes("client")))
    : [];

  useEffect(() => {

    getHelpContent()
      .then(result => {
      if (!result.items) return false;
        const categories = (result.items.map((category: any): any => category.fields));
        categories.forEach((category: any): any => {
          category.topics = category.topics.map((topic: any): any => topic.fields);
        })

      setHelpCategories(categories);
    });
  }, []);

  return (
    <BasicLayout showBackgroundImage backPath="/dashboard">
      <Container maxW="1080px" minH="100vh" px={[4, 12]} centerContent>
        <VStack spacing={8} width="100%">
          <Box w="200px" mt={24}>
            <Logo />
          </Box>
          <Heading size="lg" textAlign="center">
            Help &amp; FAQs
          </Heading>
          <SimpleGrid
            columns={{ sm: 1 }}
            templateColumns={{ sm: "1fr", md: "auto 1fr" }}
            bgColor="gray.700"
            rounded={8}
            color="white"
            width="100%"
            minChildWidth="120px"
            minH={{ md: "xl" }}
            boxShadow="0px 4px 7px -1px rgba(0, 0, 0, 0.25)"
          >
            <Categories
              categories={helpCategories}
              callback={setActiveIndex}
              activeIndex={activeIndex}
            />
            <Section topics={topics} />
          </SimpleGrid>
        </VStack>
      </Container>
    </BasicLayout>
  );
};

export default Help;
